import { ArrowUp } from "lucide-react";
import { scrollToSection } from "@/lib/scroll";
import { KIA_LOGO, DEALERSHIP } from "@/data/site";

export default function Footer() {
  const year = new Date().getFullYear();
  return (
    <footer data-testid="site-footer" className="relative bg-[#0A0F14] border-t border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8 py-16">
        <div className="flex flex-col md:flex-row md:items-start justify-between gap-12">
          <div>
            <div className="flex items-center gap-4">
              <img
                src={KIA_LOGO}
                alt="Kia"
                data-testid="footer-kia-logo"
                className="h-6 w-auto invert mix-blend-screen"
              />
              <p data-testid="footer-brand" className="font-display font-extrabold text-3xl sm:text-4xl tracking-tight text-white">
                SANJIB <span className="text-[#FFFFFF]">KIA</span>
              </p>
            </div>
            <p className="mt-2 font-mono text-[11px] uppercase tracking-[0.3em] text-slate-500">www.sanjibkia.com</p>
            <p className="mt-5 text-sm text-slate-500 max-w-sm leading-relaxed">
              {DEALERSHIP.legal} — authorized Kia dealership on NH-20, Panikoili, Jajpur.
              Movement that inspires, delivered to your doorstep.
            </p>
          </div>

          <div className="flex gap-16">
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-4">Explore</p>
              <div className="flex flex-col gap-2.5">
                {[
                  ["Lineup", "#lineup", "footer-link-lineup"],
                  ["Why Sanjib", "#manifesto", "footer-link-manifesto"],
                  ["EMI Calculator", "#emi", "footer-link-emi"],
                  ["Test Drive", "#test-drive", "footer-link-test-drive"],
                  ["Book Service", "#service", "footer-link-service"],
                ].map(([label, href, id]) => (
                  <button
                    key={href}
                    data-testid={id}
                    onClick={() => scrollToSection(href)}
                    className="text-left text-sm text-slate-400 hover:text-[#FFFFFF] transition-colors"
                  >
                    {label}
                  </button>
                ))}
              </div>
            </div>
            <div>
              <p className="font-mono text-[10px] uppercase tracking-[0.25em] text-slate-500 mb-4">Contact</p>
              <div className="flex flex-col gap-2.5 text-sm text-slate-400">
                <a data-testid="footer-phone" href={`tel:${DEALERSHIP.phoneRaw}`} className="hover:text-[#FFFFFF] transition-colors">{DEALERSHIP.phone}</a>
                <a data-testid="footer-email" href={`mailto:${DEALERSHIP.email}`} className="hover:text-[#FFFFFF] transition-colors">{DEALERSHIP.email}</a>
                <span>NH-20, Panikoili, Jajpur 755019</span>
              </div>
            </div>
          </div>

          <button
            data-testid="footer-back-to-top-button"
            onClick={() => (window.__lenis ? window.__lenis.scrollTo(0, { duration: 1.6 }) : window.scrollTo({ top: 0, behavior: "smooth" }))}
            className="self-start md:self-center w-12 h-12 grid place-items-center border border-white/15 text-white hover:border-[#FFFFFF] hover:text-[#FFFFFF] transition-colors duration-300"
            aria-label="Back to top"
          >
            <ArrowUp size={18} />
          </button>
        </div>

        <div className="mt-14 pt-7 border-t border-white/10 flex flex-col sm:flex-row justify-between gap-3">
          <p className="text-xs text-slate-600">© {year} {DEALERSHIP.legal}. All rights reserved. Kia is a registered trademark of Kia Corporation.</p>
          <p className="text-xs text-slate-600 font-mono uppercase tracking-[0.2em]">Movement That Inspires</p>
        </div>
      </div>
    </footer>
  );
}
